import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/deadline-definitions',
    name: 'deadline-definitions',
    meta: {
      title: 'Deadline Definitions'
    },
    component: () => import('@/views/deadline-definitions/DeadlineDefinitionListView.vue')
  },
  {
    path: '/deadline-definitions/create',
    name: 'deadline-definition-create',
    meta: {
      title: 'Create Deadline Definition'
    },
    component: () => import('@/views/deadline-definitions/DeadlineDefinitionCreateView.vue')
  },
  {
    path: '/deadline-definitions/:id',
    name: 'deadline-definition-edit',
    props: true,
    meta: {
      title: 'Edit Deadline Definition'
    },
    component: () => import('@/views/deadline-definitions/DeadlineDefinitionEditView.vue'),
    children: [
      {
        path: '/deadline-definitions/:id/f/:section',
        name: 'deadline-definition-edit-section',
        props: true,
        meta: {
          title: 'Edit Deadline Definition'
        },
        component: () => import('@/views/deadline-definitions/DeadlineDefinitionEditView.vue')
      }
    ]
  }
]

export default routes
